import React from "react";
import { CmaxUsersTable } from "../table/cmax-users-table";

export function CmaxUsersPage() {
  return <CmaxUsersTable fullScreenEnabled />;
}
